import { useState, useEffect } from 'react';

export function useTrialManagement(trialEnd: string | null) {
  const [isTrialActive, setIsTrialActive] = useState(false);
  const [trialDaysRemaining, setTrialDaysRemaining] = useState(0);

  useEffect(() => {
    if (!trialEnd) {
      setIsTrialActive(false);
      setTrialDaysRemaining(0);
      return;
    }

    const now = new Date();
    const trialEndDate = new Date(trialEnd);
    const timeRemaining = trialEndDate.getTime() - now.getTime();
    const daysRemaining = Math.ceil(timeRemaining / (1000 * 60 * 60 * 24));
    const remaining = Math.max(0, daysRemaining);

    console.log('[TRIAL MANAGEMENT]', {
      trial_end: trialEnd,
      days_remaining: remaining,
      is_active: remaining > 0
    });

    setTrialDaysRemaining(remaining);
    setIsTrialActive(remaining > 0);
  }, [trialEnd]);

  return { isTrialActive, trialDaysRemaining };
}
